module.exports = __webpack_public_path__ + "static/media/loader_animate.94689134.gif";